import * as React from 'react';
const SvgYoutubeBumper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
      <path
        fill="#F06050"
        d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
      />
      <path
        fill="#fff"
        d="M19.259 5.38c.08.04.137.105.179.177a.01.01 0 0 0 .012.007q.008 0 .012.008c.038.09.038.207.038.433v2c0 .834 0 1.7-.092 1.875a.9.9 0 0 1-.166.225.9.9 0 0 1-.2.142c-.175.092-1.04.092-1.873.092h-1.998c-.233 0-.35 0-.44-.042a.43.43 0 0 1-.184-.183l-.007-.014q-.012-.023-.02-.046a.3.3 0 0 1-.01-.059l-.003-.022c-.01-.075-.01-.167-.01-.3v-.334c0-.234 0-.35.042-.442a.43.43 0 0 1 .183-.183c.091-.042.208-.042.441-.042h1.345c.11 0 .173-.132.104-.217a5.83 5.83 0 0 0-4.62-2.283 5.826 5.826 0 0 0-5.827 5.833 5.826 5.826 0 0 0 5.41 5.82c.23.015.417.2.417.43v.834a.4.4 0 0 1-.417.405A7.497 7.497 0 0 1 4.5 12.005c0-4.141 3.355-7.5 7.5-7.5 1.938 0 3.692.745 5.018 1.955.29.266.809.072.809-.321v-.134c0-.233 0-.35.041-.441a.43.43 0 0 1 .184-.184.46.46 0 0 1 .208-.041h.557c.233 0 .35 0 .442.041"
      />
      <path
        fill="#fff"
        d="M11.367 7.63v4.117L9.636 13.48a.63.63 0 0 0 0 .884c.241.241.64.241.882 0l1.915-1.917a.65.65 0 0 0 .183-.442V7.63a.63.63 0 0 0-.624-.625.63.63 0 0 0-.625.625M19.488 12.423a.4.4 0 0 0-.405-.418h-.833a.44.44 0 0 0-.431.416 6 6 0 0 1-.092.696.44.44 0 0 0 .309.513l.805.216a.4.4 0 0 0 .499-.298 7.6 7.6 0 0 0 .148-1.125M18.274 16.118a.4.4 0 0 0-.142-.564l-.721-.417a.44.44 0 0 0-.582.143 6 6 0 0 1-.423.55.44.44 0 0 0 .01.6l.587.59a.4.4 0 0 0 .581-.008q.377-.42.69-.894M15.377 18.703a.4.4 0 0 0 .159-.56l-.417-.721a.44.44 0 0 0-.576-.166q-.311.151-.64.265a.44.44 0 0 0-.291.525l.215.805a.4.4 0 0 0 .507.284q.54-.178 1.043-.433"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgYoutubeBumper;
